angular.module('app').component('userSettingZone', {
    templateUrl: 'js/components/user-setting-zone/index.html',
    controller: UserSettingZoneController,
    controllerAs: '$usZone',
    bindings: {
        objectsList: '=',
        isSubmitted: '&'
    },
});

UserSettingZoneController.$inject = ['Microservice', '$translate', 'toaster', '$http'];

function UserSettingZoneController(Microservice, $translate, toaster, $http) {
    var $ctrl = this;

    $ctrl.zoneNotification = [];
    $ctrl.notification = {};
    $ctrl.saved = false;
    $ctrl.loading = false;

    $ctrl.zones = {
        list: [],
        zone: "",
        chosenZones: [],
        goToZone: function (zone) {
            $ctrl.zones.zone = zone.id.toString();
            $ctrl.objects.object = "";
            $ctrl.groups.group = "";
        },
        compareZone: function (zone) {
            var selected = Number($ctrl.zones.zone);
            return zone.id === selected;
        },
        updateChosenZones: function () {
            $ctrl.loading = true;
            for (var index in $ctrl.zoneNotification.zone) {
                var elem = $ctrl.zoneNotification.zone[index];
                $ctrl.zones.addZone(elem.zoneId);

                if (elem.objectId && $ctrl.notification[elem.zoneId].objects.ids.indexOf(elem.objectId) < 0) {
                    $ctrl.notification[elem.zoneId].objects.ids.push(elem.objectId);
                    $ctrl.notification[elem.zoneId].objects.settings[elem.objectId] = {
                        in: elem.in,
                        out: elem.out
                    };
                }

                if (elem.groupId && $ctrl.notification[elem.zoneId].groups.ids.indexOf(elem.groupId) < 0) {
                    $ctrl.notification[elem.zoneId].groups.ids.push(elem.groupId);
                    $ctrl.notification[elem.zoneId].groups.settings[elem.groupId] = {
                        in: elem.in,
                        out: elem.out
                    };
                }
            }
            $ctrl.loading = false;
        },
        addZone: function (id) {
            var selected = id;
            if (selected && $ctrl.zones.chosenZones.indexOf(selected) < 0) {
                $ctrl.zones.chosenZones.push(selected);
            }

            if (selected && !$ctrl.notification.hasOwnProperty(selected)) {
                $ctrl.notification[selected] = {
                    objects: {
                        settings: {},
                        ids: []
                    },
                    groups: {
                        settings: {},
                        ids: []
                    }
                }
            }
        },
        addCurrentZone: function () {
            $ctrl.zones.addZone(Number($ctrl.zones.zone))
            $ctrl.objects.object = "";
            $ctrl.groups.group = "";
        },
        loadZones: function() {
            Microservice.interceptor('zone', 'get', '/zone-notifications').then(function (response) {
                $ctrl.zoneNotification = response.data;
                $ctrl.zones.updateChosenZones();
            }).catch(function (err) {
                console.error(err);
            });
        }
    }

    $ctrl.objects = {
        list: [],
        object: "",
        goToObject: function (object) {
            $ctrl.objects.object = object.objectId.toString();
        },
        addObjectToZone: function () {
            var selected = $ctrl.zones.zone;
            var selectedObject = Number($ctrl.objects.object);

            if (selectedObject && $ctrl.notification[selected].objects.ids.indexOf(selectedObject) < 0) {
                $ctrl.notification[selected].objects.ids.push(selectedObject);
                $ctrl.notification[selected].objects.settings[selectedObject] = {
                    in: true,
                    out: true
                };
            }
        },
        compareObject: function (object) {
            return object.objectId === Number($ctrl.objects.object);
        }
    }

    $ctrl.groups = {
        list: [],
        group: "",
        goToGroup: function (group) {
            $ctrl.groups.group = group.groupId.toString();
        },
        addGroupToZone: function () {
            var selected = $ctrl.zones.zone;
            var selectedGroup = Number($ctrl.groups.group);

            if (selectedGroup && $ctrl.notification[selected].groups.ids.indexOf(selectedGroup) < 0) {
                $ctrl.notification[selected].groups.ids.push(selectedGroup);
                $ctrl.notification[selected].groups.settings[selectedGroup] = {
                    in: true,
                    out: true
                };
            }
        },
        compareGroup: function (group) {
            return group.groupId === Number($ctrl.groups.group);
        }
    }

    $ctrl.$onInit = function () {
        Microservice.interceptor('zone', 'get', '/zones').then(function (response) {
            $ctrl.zones.list = response.data;
        }).catch(function (err) {
            console.error(err);
        });

        $http.get('/api/group/list').then(function (response) {
            $ctrl.groups.list = response.data.data.groups;
        }).catch(function (err) {
            console.error(err);
        });

        $ctrl.zones.loadZones();
        $ctrl.objects.list = this.objectsList;
    };

    $ctrl.$doCheck = function () {
        if (this.isSubmitted() && !$ctrl.saved) {
            $ctrl.save();
        }
    };

    $ctrl.buildPayload = function () {
        var payload = {
            zone: [],
            zone_groups: []
        }

        for (var zoneId in $ctrl.notification) {
            for (var index in $ctrl.notification[zoneId].objects.ids) {
                var objectId = $ctrl.notification[zoneId].objects.ids[index];
                payload.zone.push({
                    zoneId: Number(zoneId),
                    in: $ctrl.notification[zoneId].objects.settings[objectId].in,
                    out: $ctrl.notification[zoneId].objects.settings[objectId].out,
                    objectId: objectId,
                    groupId: null
                });
            }
            for (var index in $ctrl.notification[zoneId].groups.ids) {
                var groupId = $ctrl.notification[zoneId].groups.ids[index];
                payload.zone.push({
                    zoneId: Number(zoneId),
                    in: $ctrl.notification[zoneId].groups.settings[groupId].in,
                    out: $ctrl.notification[zoneId].groups.settings[groupId].out,
                    groupId: groupId,
                    objectId: null
                });
            }
        }

        return payload;
    }

    $ctrl.save = function () {
        $ctrl.saved = true;
        var payload = $ctrl.buildPayload();

        Microservice.interceptor('zone', 'post', '/zone-notifications', payload).then(
            function () {
                $ctrl.saved = false;
            },
            function () {
                $ctrl.saved = false;
                toaster.pop(
                    'error',
                    $translate.instant('settings.toastr.error.header'),
                    $translate.instant('settings.filters.zone.notification.toastr.error')
                );
            }).catch(function (err) {
                console.error(err);
            });
    }
}
